import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { injectIntl, FormattedMessage } from 'react-intl';

export const showFormattedText = (section, page, zone, intl) => {
  const retVal = {};

  const EMPHASIZED_TERMS = {
    tour: {
      1: {
        text_1: ['platform', 'building', 'initial_idea', 'settling'],
        text_2: ['first_step', 'search_problem', 'solution'],
      },
    },
  };

  //console.log('Emphasized terms: ', EMPHASIZED_TERMS);

  //console.log(`${section} ${page} ${zone}`);

  EMPHASIZED_TERMS[section][page][zone].map(
    // eslint-disable-next-line no-return-assign
    text => (retVal[text] = <b>{intl.formatMessage({ id: text })}</b>),
  );

 // console.log('Formatted: ', retVal);

  return retVal;
};

export const ContentItem = injectIntl(({ page, section, intl }) => (
  <div>
    <Row>
      <Col md={12} xs={12}>
        <h1 style={{ fontWeight: 'bold' }}>
          {intl.formatMessage({
            id: `${section}.page_${page}.title_1`,
          })}
        </h1>
        <h4 className="text-description">
          {intl.formatMessage({
            id: `${section}.page_${page}.text_1`,
          })}

          {/* <FormattedMessage
            id={`${section}.page_${page}.text_1`}
            values={showFormattedText(section, page, 'text_1', intl)}
          /> */}
        </h4>
      </Col>
    </Row>
    <Row>
      <Col md={12} xs={12}>
        <h1 style={{ fontWeight: 'bold' }}>
          {intl.formatMessage({
            id: `${section}.page_${page}.title_2`,
          })}
        </h1>
        <h4 className="text-description">
          {intl.formatMessage({
            id: `${section}.page_${page}.text_2`,
          })}
        </h4>
      </Col>
    </Row>
  </div>
));

export default ContentItem;
